module.exports = __webpack_public_path__ + "media/images/main-logo-d48595d84c77cad681c37ebf34647096.png";